const ROUTES_NAME = {
    LOGIN: '/',
    INSTRUCTION: '/instructions',
    DASHBOARD: '/myexam',
    REGISTRATION: '/faceregistration',
    FACE_VERIFICATION: '/face-verification',
    TEST: '/test',
    THANK_YOU:'/thankyou',
    EXAM_SCORE:'/exam-score',
    EXAM_RESULT:'/exam-result',
    AUTH_ERROR:'/auth-error',
    SUBJECT_SELECTION:'/subject-selection'
  };
  
  export default ROUTES_NAME;
  